import Routing from '../backend-router';
import GenericApi from './GenericApi';

import axios from 'axios';

axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;
axios.defaults.withCredentials = true;
axios.defaults.timeout = 0;


// in case of a 401 response for any request, redirect to login page
let redirectAsked = false; // TODO PIERRE: lorsque le business de check credentials d'adrian est cleané, on aura probablement plus besoin de ce flag...
axios.interceptors.response.use(
    undefined, // don't intercept when no error
    error =>{
        if (is401(error) && !redirectAsked) {
            redirectAsked = true;
            console.log('redirect to login page...');
            window.location.href = process.env.VUE_APP_API_BASE_URL;
            // javascript execution must be stopped in the catch clause of the request
        }
        return Promise.reject(error);
    }
);

const genericApi = new GenericApi(axios);

function is401(error) {
    return error.response !== undefined && error.response.status === 401;
}

export default {
    user : {
        async me() {
            return await genericApi.request({
                method: 'get',
                url: Routing.generate('worker_interface_user_me')
            });
        }
    },
    worker: {
        async closeModalCongratulations(workerId) {
            return await genericApi.request({
                method: 'post',
                url: Routing.generate('worker_close_badge_congratulations',{worker:workerId}),
                selector: responseData => responseData.data,
            });
        },
        async getBadges() {
            return await genericApi.request({
                method: 'get',
                url: Routing.generate('worker_get_badges'),
                selector: responseData => responseData.data,
            });
        },
        async missedJobs() {
            return await genericApi.request({
                method: 'get',
                url: Routing.generate('worker_get_missed_jobs'),
            });
        },
        async readMissedJobs() {
            return await genericApi.request({
                method: 'post',
                url: Routing.generate('worker_read_missed_jobs'),
            });
        },
        async checkMissedJobs() {
            return await genericApi.request({
                method: 'get',
                url: Routing.generate('worker_check_missed_jobs'),
            });
        },
        async dontShowMessageTutorial(user_id) {
            return await genericApi.request({
                method: 'post',
                url: Routing.generate('worker_interface_worker_dont_show_message_tutorial', {'worker': user_id}),
            });
        },
        async duplicateJob(jobId){
            return await genericApi.request({
                method: 'post',
                url: Routing.generate('worker_interface_worker_duplicate_job', {originalJob: jobId}),
            });
        },
        async createQuotation(jobID, data){
            return await genericApi.request({
                method: 'post',
                url: Routing.generate('worker_interface_worker_create_quotation', {job: jobID}),
                data: data,
            });
        },
        async synchronizeJobs(workerInterventionsEdited){
            return await genericApi.request({
                method: 'post',
                url: Routing.generate('worker_interface_worker_synchronize_jobs'),
                data: JSON.stringify(workerInterventionsEdited),
                cancelingPrevious: true,
                requestName: 'worker_interface_worker_synchronize_jobs'
            });
        },
        async alertWebmasterAndHidePromotedMessage(){
            return await genericApi.request({
                method: 'post',
                url: Routing.generate('worker_interface_alert_webmaster_and_hide_promoted_message'),
                cancelingPrevious: true,
                requestName: 'worker_interface_alert_webmaster_and_hide_promoted_message'
            });
        },
        async uploadPictureLogo(workerId, formData, onUploadProgress){
            return await genericApi.request({
                method: 'post',
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                url: Routing.generate('worker_interface_worker_upload_picture', {workerId: workerId}),
                axiosOptions: {onUploadProgress, timeout : 0},
                data: formData
            });
        },

        async deletePictureLogo(workerId){
            return await genericApi.request({
                method: 'post',
                url: Routing.generate('worker_interface_worker_delete_picture', {workerId: workerId}),
            });
        },
        async sendLead(workerId, data) {
            return await genericApi.request({
                method: 'post',
                url: Routing.generate('worker_send_lead',{worker:workerId}),
                data:data
            });
        },
        async getLeads() {
            return await genericApi.request({
                method: 'get',
                url: Routing.generate('worker_get_leads'),
                selector: responseData => responseData.leads,
            });
        },
        async getBadgeAlert() {
            return await genericApi.request({
                method: 'get',
                url: Routing.generate('worker_get_badge_alert'),
                selector: responseData => responseData,
            });
        },
        async dismissBadgeAlert(workerBadgePointId) {
            return await genericApi.request({
                method: 'post',
                url: Routing.generate('worker_dismiss_badge_alert'),
                data:{workerBadgePointId:workerBadgePointId}
            });
        },
        async savePreferences(data) {
            return await genericApi.request({
                method: 'post',
                url: Routing.generate('worker_save_preferences'),
                data:data
            });
        },
        async getPreferences() {
            return await genericApi.request({
                method: 'get',
                url: Routing.generate('worker_get_preferences'),
                selector: responseData => responseData.data,
            });
        },
    },
    address: {
        async createNewBillingAddress(data_address, customer_id){
            return await genericApi.request({
                method: 'post',
                url: Routing.generate('worker_interface_address_new_billing_address', {customer: customer_id}),
                data: data_address,
            });
        },
        async getZones(zipCode, country){
            return await genericApi.request({
                method: 'get',
                url: Routing.generate('worker_interface_address_address_get_zones', {'zipCode':zipCode, 'country':country}),
                cancelingPrevious: true,
                selector: responseData => responseData.zones,
                requestName: 'worker_interface_address_address_get_zones'
            });
        },
        async getZone(zoneId){
            return await genericApi.request({
                method: 'get',
                url: Routing.generate('worker_interface_address_address_get_zone', {'zone':zoneId}),
                selector: responseData => responseData.zone,
                requestName: 'worker_interface_address_address_get_zone'
            });
        }
    },
    job: {
        async getJobs() {
            return await genericApi.request({
                method: 'get',
                url: Routing.generate('worker_interface_job_get_jobs'),
            });
        },
        async getJobsOfWorkerOwner() {
            return await genericApi.request({
                method: 'get',
                url: Routing.generate('worker_interface_job_get_worker_jobs_owner'),
                selector: responseData => responseData.jobs,
            });
        },
        async getCustomerPhone(jobID) {
            return await genericApi.request({
                method: 'get',
                url: Routing.generate('worker_interface_job_get_customer_phone', {job: jobID}),
            });
        },
        async createContinuationJob(originalJobId, dateJobStartString, durationRequired, remark, timeout) {
            return await genericApi.request({
                method: 'post',
                axiosOptions: {timeout : timeout},
                url: Routing.generate('worker_interface_job_create_continuation_job'),
                data: {
                    originalJobId,
                    dateJobStart: dateJobStartString,
                    durationRequired,
                    remark
                }
            });
        },
        async getRefundInfos(jobId) {
            return await genericApi.request({
                method: 'get',
                url: Routing.generate('worker_interface_job_get_refund_infos', {job: jobId}),
                selector: responseData => responseData.refundInfos,
            });
        },
        async markAsImpossible(jobId, comment) {
            return await genericApi.request({
                method: 'post',
                url: Routing.generate('worker_interface_job_mark_as_impossible', {job: jobId}),
                data: {comment}
            });
        },
        async markAsNotAbleToGo(jobId) {
            return await genericApi.request({
                method: 'post',
                url: Routing.generate('worker_interface_job_mark_as_not_able_to_go', {job: jobId}),
            });
        },
        // Announces a delay. The job stays open and keeps its worker, so this is
        // NOT one of the fail declarations above.
        async markAsRunningLate(jobId, delayMinutes) {
            return await genericApi.request({
                method: 'post',
                url: Routing.generate('worker_interface_job_mark_as_running_late', {job: jobId}),
                data: {delayMinutes}
            });
        },
        async markAsCustomerNotOkOnPhone(jobId) {
            return await genericApi.request({
                method: 'post',
                url: Routing.generate('worker_interface_job_mark_as_customer_not_ok_on_phone', {job: jobId}),
            });
        },
        async swap(jobAId, jobBId) {
            return await genericApi.request({
                method: 'post',
                url: Routing.generate('worker_interface_job_swap', {jobA: jobAId, jobB: jobBId}),
                selector: responseData => responseData.swapped,
            });
        },
        async saveSparePartsAmount(JobId, amount){
            return await genericApi.request({
                method: 'post',
                url: Routing.generate('worker_interface_save_spare_parts_amount', {job: JobId}),
                data: {
                    sparePartsAmount:amount
                },
            });
        },
        async addJobAsWorkerOwner(job){
            return await genericApi.request({
                method: 'post',
                url: Routing.generate('worker_interface_add_job_as_worker_owner'),
                data: job,
            });
        },
        async updateJobAsWorkerOwner(job){
            return await genericApi.request({
                method: 'post',
                url: Routing.generate('worker_interface_update_job_as_worker_owner'),
                data: job,
            });
        },
        async jobCancelForWorkerOwner(jobId){
            return await genericApi.request({
                method: 'post',
                url: Routing.generate('worker_interface_job_cancel_for_worker_owner',{job:jobId}),
            });
        },
        async getJobHistoryAndRelated(jobID) {
            return await genericApi.request({
                method: 'get',
                url: Routing.generate('worker_interface_job_history_and_related', {job: jobID}),
                selector: responseData => responseData.jobs,
            });
        },
        async discloseJob(jobID) {
            return await genericApi.request({
                method: 'post',
                url: Routing.generate('worker_interface_disclose_job', {job: jobID}),
                selector: responseData => responseData.jobs,
            });
        },
        async getJob(jobId) {
            return await genericApi.request({
                method: 'get',
                url: Routing.generate('worker_interface_get_worker_owner', {job: jobId}),
                selector: responseData => responseData.job,
            });
        },
    },
    voucher: {
        async sendVoucherByEmail(jobID, customerEmail){
            return await genericApi.request({
                method: 'post',
                url: Routing.generate('worker_interface_voucher_send_voucher_by_email', {job: jobID}),
                data:  {
                    job: jobID,
                    customer_email : customerEmail
                },
            });
        },
    },
    picture : {
        async deletePicture(pictureId){
            return await genericApi.request({
                method: 'post',
                url: Routing.generate('worker_interface_picture_delete_picture', {picture: pictureId}),
            });
        },
        async newPicture(jobID, formData, onUploadProgress){
            return await genericApi.request({
                method: 'post',
                url: Routing.generate('worker_interface_picture_new_picture', {job: jobID}),
                axiosOptions: {onUploadProgress, timeout : 0},
                data: formData
            });
        },
        async getPicturesOfJobAndDocument(documentID, tag){
            return await genericApi.request({
                method: 'get',
                url: Routing.generate('worker_interface_picture_get_pictures_of_job_and_document', {document: documentID, tag: tag})
            });
        },
    },
    holiday: {
        async days() {
            return await genericApi.request({
                method: 'get',
                url: Routing.generate('worker_interface_holiday_days'),
                selector: responseData => responseData.days,
                cancelingPrevious: true,
                requestName: 'worker_interface_holiday_days'
            });
        },
        async day(date) {
            return await genericApi.request({
                method: 'get',
                url: Routing.generate('worker_interface_holiday_day', {date}),
                selector: responseData => responseData.day,
            });
        },
        async updateDayPunctual(date, hours) {
            await genericApi.request({
                method: 'post',
                url: Routing.generate('worker_interface_holiday_update_day_punctual', {date}),
                data: hours
            });
        },
        async updateDayWeekly(date, hours) {
            await genericApi.request({
                method: 'post',
                url: Routing.generate('worker_interface_holiday_update_day_weekly', {date}),
                data: hours
            });
        },
        async getListOfRefundInfos(date, hours) {
            return await genericApi.request({
                method: 'post',
                url: Routing.generate('worker_interface_holiday_get_list_of_refund_infos', {date}),
                data: hours,
                selector: responseData => responseData.listOfRefundInfos,
            });
        },
    },
    quotation: {
        async updateQuotation(documentID, data){
            return await genericApi.request({
                method: 'post',
                url: Routing.generate('worker_interface_worker_update_quotation', {document: documentID}),
                selector: responseData => responseData,
                data: data,
            });
        },
        async createQuotation(jobID, data){
            return await genericApi.request({
                method: 'post',
                url: Routing.generate('worker_interface_worker_create_quotation', {job: jobID}),
                selector: responseData => responseData,
                data: data,
            });
        }
    },
    invoice: {
        async addInvoiceAndSendByEmailToCustomer(job){
            return await genericApi.request({
                method: 'post',
                url: Routing.generate('worker_interface_add_invoice_and_send_by_email_to_customer', {job: job.id}),
                selector: responseData => responseData,
                data: {
                    voucher:job.workerIntervention.voucher,
                    addressId : job.customer.address_current.id,
                    email : job.customer.email
                },
            });
        },
    },
    documents : {
        async getDocumentsOfWorkerByDateRangeAndType(dataSearch){
            return await genericApi.request({
                method: 'post',
                url: Routing.generate('worker_interface_get_documents_of_worker_by_date_range_and_type'),
                selector: responseData => responseData,
                data : dataSearch
            });
        },
        async getListOfQuarterlyPdfOfWorker(){
            return await genericApi.request({
                method: 'get',
                url: Routing.generate('worker_interface_get_list_of_quarterly_pdf_of_worker'),
                selector: responseData => responseData
            });
        }
    },
    jobType: {
        async tree() {
            return await genericApi.request({
                method: 'get',
                url: Routing.generate('worker_interface_job_type_tree'),
                selector: responseData => responseData.jobTypes
            });
        },
        async list() {
            return await genericApi.request({
                method: 'get',
                url: Routing.generate('worker_interface_job_type_list'),
                selector: responseData => responseData.workerJobTypes
            });
        },
        async update(jobTypesIds) {
            return await genericApi.request({
                method: 'post',
                url: Routing.generate('worker_interface_job_type_update'),
                data: jobTypesIds
            });
        },
        async jobTypesOfWorker() {
            return await genericApi.request({
                method: 'get',
                url: Routing.generate('worker_interface_job_types_of_worker'),
                selector: responseData => responseData.workerJobTypes
            });
        },
    },
    slot: {
        async suggest(originalJobId, durationRequired, customerAddressZipCode) {
            return await genericApi.request({
                method: 'get',
                url: Routing.generate('worker_interface_slot_suggest', {
                    originalJobId,
                    durationRequired,
                    customerAddressZipCode
                }),
                selector: responseData => responseData.slots,
                cancelingPrevious: true,
                requestName: 'worker_interface_slot_suggest'
            });
        },
        async suggestForWorker(queryParams) {
            return await genericApi.request({
                method: 'get',
                url: Routing.generate('worker_interface_slot_suggest_for_worker',queryParams),
                selector: responseData => responseData.slots,
                cancelingPrevious: true,
                requestName: 'worker_interface_slot_suggest_for_worker'
            });
        },

    },
    transaction : {
        async getTransactionsAndBalance(workerId, last_transaction_id) {
            return await genericApi.request({
                method: 'get',
                url: Routing.generate('worker_interface_pure_contact_get_transactions_and_balance', {'worker':workerId,'last_transaction_id':last_transaction_id})
            });
        },
    },
    alert: {
        async getAlertsOfWorker(workerId) {
            return await genericApi.request({
                method: 'get',
                url: Routing.generate('worker_interface_get_alerts_of_worker', {'worker':workerId})
            });
        },
        async submitConfirmation(alertMessage) {
            return await genericApi.request({
                method: 'post',
                url: Routing.generate('worker_interface_confirm_alert_with_message', {'alert':alertMessage.id}),
                data : alertMessage
            });
        },
        async setAlertAsClosed(alertId) {
            return await genericApi.request({
                method: 'get',
                url: Routing.generate('worker_interface_set_alert_as_closed', {'alert':alertId})
            });
        },
        async responseOfAlertJobWarranty(alert, responseOfAcceptence) {
            return await genericApi.request({
                method: 'post',
                url: Routing.generate('worker_interface_response_of_alert_job_warranty', {'alert': alert.id}),
                data : {'responseOfAcceptence' : responseOfAcceptence, 'message' : alert.confirmationMessage }
            });
        },
        async responseOfAlertMissingWorkerLogo(alert) {
            return await genericApi.request({
                method: 'post',
                url: Routing.generate('worker_interface_response_of_alert_missing_worker_logo', {'alert': alert.id}),
                data : {'alert': alert }
            });
        },
        async responseAlertDevis(alertMessage) {
            return await genericApi.request({
                method: 'post',
                url: Routing.generate('worker_interface_response_alert_devis', {'alert':alertMessage.id}),
                data : alertMessage
            });
        },
        async snoozeAlert(alertMessage) {
            return await genericApi.request({
                method: 'post',
                url: Routing.generate('worker_interface_snooze_alert', {'alert':alertMessage.id}),
                data : alertMessage
            });
        },
        async cancelDevis(alertMessage) {
            return await genericApi.request({
                method: 'post',
                url: Routing.generate('worker_interface_cancel_devis', {'alert':alertMessage.id}),
                data : alertMessage
            });
        },

    },
    isCancel(error) {
        return axios.isCancel(error);
    },
    is401,
    isNoConnectivity(error) {
        return error.request && !error.response;
    }
}
